import { render, staticRenderFns } from "./document_kendala_name_pdf.vue?vue&type=template&id=35851a02"
import script from "./document_kendala_name_pdf.vue?vue&type=script&lang=js"
export * from "./document_kendala_name_pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports